export interface TransactionGlLine {
	period: string;
	date: string;
	/** Raw trandate (Y-m-d) from API; used for edit dialog */
	trandateRaw?: string;
	periodno?: number;
	/** GL line id for generalledger/updategltransline */
	counterindex?: number;
	/** GL account name */
	account: string;
	accountcode?: string;
	description: string;
	/** Department / GL tag (from tags.tagdescription or #tagref) */
	department?: string;
	tagref?: number;
	tagdescription?: string;
	debit: number;
	credit: number;
	posted: string;
}

export function normalizeTransactionGlLines(raw: unknown): TransactionGlLine[] {
	if (!Array.isArray(raw)) {
		return [];
	}
	return raw.map((row: any) => {
		const dept =
			row?.department != null && String(row.department).trim() !== ''
				? String(row.department)
				: row?.tagdescription != null && String(row.tagdescription).trim() !== ''
					? String(row.tagdescription)
					: row?.tagref != null && Number(row.tagref) > 0
						? '#' + String(row.tagref)
						: '';
		const ci = row?.counterindex != null ? Number(row.counterindex) : NaN;
		const pn = row?.periodno != null ? Number(row.periodno) : NaN;
		return {
			period: row?.period != null ? String(row.period) : '',
			date: row?.date != null ? String(row.date) : '',
			trandateRaw:
				row?.trandate != null && String(row.trandate).trim() !== ''
					? String(row.trandate).slice(0, 10)
					: '',
			periodno: !Number.isNaN(pn) ? pn : undefined,
			counterindex: !Number.isNaN(ci) && ci > 0 ? ci : undefined,
			account: row?.account != null ? String(row.account) : '',
			accountcode: row?.accountcode != null ? String(row.accountcode) : '',
			description: row?.description != null ? String(row.description) : '',
			department: dept,
			tagref: row?.tagref != null ? Number(row.tagref) : undefined,
			tagdescription:
				row?.tagdescription != null ? String(row.tagdescription) : undefined,
			debit: Number(row?.debit) || 0,
			credit: Number(row?.credit) || 0,
			posted: row?.posted != null ? String(row.posted) : '',
		};
	});
}
